import { render, staticRenderFns } from "./taskItem.vue?vue&type=template&id=44795892&scoped=true"
import script from "./taskItem.vue?vue&type=script&lang=js"
export * from "./taskItem.vue?vue&type=script&lang=js"
import style0 from "./taskItem.vue?vue&type=style&index=0&id=44795892&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44795892",
  null
  
)

export default component.exports